














































































































import { CourseModuleResponseDTO } from '@/store/modules/jtms/course-module/course-module.types';
import {
  TrainerResponseDTO,
  TrainerRowObject
} from '@/store/modules/jtms/trainer/trainer.types';
import { RootState } from '@/store/store';
import TableSectionTitle from '@/views/AdminViewGroup/components/TableSectionTitle.vue';
import dayjs from 'dayjs';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

interface ModulePair {
  label: string;
  actualId: number;
}

@Component({
  components: {
    TableSectionTitle
  }
})
export default class CourseModulesTable extends Vue {
  @State((state: RootState) => state.course.courseDetails?.courseModules)
  public courseModules!: CourseModuleResponseDTO[];
  // Local variable to trigger conditional CSS styling
  hideTable: boolean = false;

  courseModulePairs: ModulePair[] = [];
  // Cloned prop to prevent directly mutating state
  clonedCourseModules: CourseModuleResponseDTO[] = [];

  mounted() {
    this.clonedCourseModules = this.courseModules;

    if (this.clonedCourseModules.length > 0) {
      this.courseModulePairs = this.assignCourseModulePairs(
        this.clonedCourseModules
      );
    }

    if (this.shouldHideTable) {
      this.hideTable = this.shouldHideTable;
    }
  }

  get shouldHideTable() {
    return this.courseModules.length > 1;
  }

  renderModules(courseModules: CourseModuleResponseDTO) {
    if (!courseModules.module) {
      return '';
    }

    return courseModules.module.name;
  }

  assignCourseModulePairs(
    courseModules: CourseModuleResponseDTO[]
  ): ModulePair[] {
    return courseModules.map((module, index) => ({
      label: `Module ${index + 1}`,
      actualId: module.id!
    }));
  }

  renderCourseModules(
    courseModules: CourseModuleResponseDTO,
    index: number
  ): ModulePair {
    return {
      label: `Module ${index + 1}`,
      actualId: courseModules.id!
    };
  }

  renderTrainers(trainer: TrainerRowObject[]): string {
    return trainer
      .map((value) => {
        return `${value.trainer.userProfile.firstName} ${value.trainer.userProfile.lastName}`;
      })
      .filter((value) => value)
      .join(', ');
  }

  renderAccreditations(trainer: TrainerRowObject[]): string {
    const accreditations = trainer
      .map((value) => value.courseType?.name ?? '')
      .filter((value) => value);

    const uniqueAccreditations = new Set(accreditations);
    return [...uniqueAccreditations].join(', ');
  }

  parseDatetime(date?: string): string {
    if (!date) {
      return '';
    }

    return dayjs(date).format('DD MMM YYYY h[:]mmA');
  }

  renderNote(courseModules: CourseModuleResponseDTO) {
    if (!courseModules.note) {
      return '';
    }
    return courseModules.note;
  }

  renderPrereqs(courseModule: CourseModuleResponseDTO) {
    if (courseModule.prerequisites?.length === 0) {
      return '';
    }

    return courseModule.prerequisites
      ?.map(
        (prereqs) =>
          this.courseModulePairs.find((pair) => pair.actualId === prereqs.id)
            ?.label
      )
      .filter((val) => val)
      .join(', ');
  }

  toggleModuleTable(isCollapsed: boolean) {
    this.hideTable = isCollapsed;
  }
}
